<div class="gstar-card" role="link" tabIndex="0">
  @if (icon) {
    <div class="gstar-card-according component-thumb">
      <span class="ap-font-48 Appkit4-icon" [ngClass]="icon"></span>
    </div>
  }
  <div class="gstar-card-description">
    <div class="gstar-card-head">
      <span class="gstar-card-name">
        {{ title }}
      </span>
    </div>
    <p class="gstar-card-desc">
      <ng-content></ng-content>
    </p>
  </div>
</div>
